export enum TradeBlotterSide {
  BUY = 'BUY',
  COVER = 'COVER',
  SELL = 'SELL',
  SHORT = 'SHORT',
  UNKNOWN = 'UNKNOWN',
}
